import React from 'react';
import { Link } from 'react-router-dom';

export const WizardConsentNotice = ({ language }) => {
  if (language === 'es') {
    return (
      <p
        className="text-xs text-gray-500 leading-relaxed mt-6"
        data-testid="wizard-consent-notice"
      >
        Al enviar tu solicitud, aceptas los{' '}
        <Link to="/terms" target="_blank" rel="noopener noreferrer"
          className="underline hover:text-blue-900" data-testid="wizard-terms-link">
          Términos y Condiciones
        </Link>{' '}
        y el{' '}
        <Link to="/privacy" target="_blank" rel="noopener noreferrer"
          className="underline hover:text-blue-900" data-testid="wizard-privacy-link">
          Aviso de Privacidad
        </Link>{' '}
        de BIMCORP, y consientes el tratamiento de tus datos personales conforme a dicho aviso.
      </p>
    );
  }

  return (
    <p
      className="text-xs text-gray-500 leading-relaxed mt-6"
      data-testid="wizard-consent-notice"
    >
      By submitting your request, you accept BIMCORP&apos;s{' '}
      <Link to="/terms" target="_blank" rel="noopener noreferrer"
        className="underline hover:text-blue-900" data-testid="wizard-terms-link">
        Terms and Conditions
      </Link>{' '}
      and{' '}
      <Link to="/privacy" target="_blank" rel="noopener noreferrer"
        className="underline hover:text-blue-900" data-testid="wizard-privacy-link">
        Privacy Notice
      </Link>
      , and consent to the processing of your personal data in accordance with that notice.
    </p>
  );
};
